import { render, staticRenderFns } from "./depsys.vue?vue&type=template&id=3c7bbfff&scoped=true&"
import script from "./depsys.vue?vue&type=script&lang=js&"
export * from "./depsys.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c7bbfff",
  null
  
)

export default component.exports